/* tslint:disable */
/* eslint-disable */
/**
 * 
 * @export
 * @interface AmountWithUnit
 */
export interface AmountWithUnit {
    /**
     * 
     * @type {number}
     * @memberof AmountWithUnit
     */
    amount: number;
    /**
     * 
     * @type {ProductionUnit}
     * @memberof AmountWithUnit
     */
    unit: ProductionUnit;
}
/**
 * 
 * @export
 * @interface ApiSimulationParameterValue
 */
export interface ApiSimulationParameterValue {
    /**
     * 
     * @type {number}
     * @memberof ApiSimulationParameterValue
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ApiSimulationParameterValue
     */
    value: string;
}
/**
 * 
 * @export
 * @interface AutoPlanRequest
 */
export interface AutoPlanRequest {
    /**
     * If selectAll is false, task IDs to plan. If selectAll is true, task IDs to exclude
     * @type {Array<number>}
     * @memberof AutoPlanRequest
     */
    taskIds?: Array<number>;
    /**
     * Whether to pull dependencies
     * @type {boolean}
     * @memberof AutoPlanRequest
     */
    pullPlanning: boolean;
    /**
     * Whether to select all relevant tasks (respecting the filter)
     * @type {boolean}
     * @memberof AutoPlanRequest
     */
    selectAll?: boolean;
    /**
     * 
     * @type {TaskFilterDefinition}
     * @memberof AutoPlanRequest
     */
    filter?: TaskFilterDefinition;
}
/**
 * 
 * @export
 * @interface AutoPlanRequestDependencies
 */
export interface AutoPlanRequestDependencies {
    /**
     * 
     * @type {Array<number>}
     * @memberof AutoPlanRequestDependencies
     */
    taskIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof AutoPlanRequestDependencies
     */
    dependencies?: Array<number>;
}
/**
 * 
 * @export
 * @interface AvailableQueue
 */
export interface AvailableQueue {
    /**
     * 
     * @type {number}
     * @memberof AvailableQueue
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof AvailableQueue
     */
    queueId: number;
    /**
     * 
     * @type {string}
     * @memberof AvailableQueue
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableQueue
     */
    shortName: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableQueue
     */
    suggestedStart: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableQueue
     */
    suggestedEnd: string;
    /**
     * 
     * @type {number}
     * @memberof AvailableQueue
     */
    duration: number;
}
/**
 * 
 * @export
 * @interface BatchGanttViewBase
 */
export interface BatchGanttViewBase {
    /**
     * 
     * @type {number}
     * @memberof BatchGanttViewBase
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof BatchGanttViewBase
     */
    queueId: number;
    /**
     * 
     * @type {string}
     * @memberof BatchGanttViewBase
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BatchGanttViewBase
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof BatchGanttViewBase
     */
    end: string;
    /**
     * 
     * @type {number}
     * @memberof BatchGanttViewBase
     */
    duration: number;
    /**
     * 
     * @type {Array<TaskGanttView>}
     * @memberof BatchGanttViewBase
     */
    tasks?: Array<TaskGanttView>;
    /**
     * 
     * @type {Array<ResourceView>}
     * @memberof BatchGanttViewBase
     */
    softResourceAssignments?: Array<ResourceView>;
    /**
     * 
     * @type {number}
     * @memberof BatchGanttViewBase
     */
    requiredSoftResourcesAmount: number;
    /**
     * 
     * @type {TaskStatus}
     * @memberof BatchGanttViewBase
     */
    status: TaskStatus;
    /**
     * 
     * @type {GanttObjectType}
     * @memberof BatchGanttViewBase
     */
    tpe: GanttObjectType;
}
/**
 * 
 * @export
 * @interface BatchKanbanViewBase
 */
export interface BatchKanbanViewBase {
    /**
     * 
     * @type {number}
     * @memberof BatchKanbanViewBase
     */
    batchId: number;
    /**
     * 
     * @type {number}
     * @memberof BatchKanbanViewBase
     */
    queueId: number;
    /**
     * 
     * @type {string}
     * @memberof BatchKanbanViewBase
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BatchKanbanViewBase
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof BatchKanbanViewBase
     */
    end: string;
    /**
     * 
     * @type {number}
     * @memberof BatchKanbanViewBase
     */
    duration: number;
    /**
     * 
     * @type {Array<KanbanTaskView>}
     * @memberof BatchKanbanViewBase
     */
    tasks?: Array<KanbanTaskView>;
    /**
     * 
     * @type {Array<ResourceView>}
     * @memberof BatchKanbanViewBase
     */
    softResourceAssignments?: Array<ResourceView>;
    /**
     * 
     * @type {TaskStatus}
     * @memberof BatchKanbanViewBase
     */
    status: TaskStatus;
    /**
     * 
     * @type {boolean}
     * @memberof BatchKanbanViewBase
     */
    wasPaused: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BatchKanbanViewBase
     */
    isOngoing: boolean;
    /**
     * 
     * @type {KanbanObjectType}
     * @memberof BatchKanbanViewBase
     */
    tpe: KanbanObjectType;
}
/**
 * 
 * @export
 * @interface BatchShortViewBase
 */
export interface BatchShortViewBase {
    /**
     * 
     * @type {number}
     * @memberof BatchShortViewBase
     */
    batchId: number;
    /**
     * 
     * @type {Queue}
     * @memberof BatchShortViewBase
     */
    queue?: Queue;
    /**
     * 
     * @type {string}
     * @memberof BatchShortViewBase
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof BatchShortViewBase
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof BatchShortViewBase
     */
    end?: string;
    /**
     * 
     * @type {number}
     * @memberof BatchShortViewBase
     */
    duration?: number;
    /**
     * 
     * @type {Array<TaskShortView>}
     * @memberof BatchShortViewBase
     */
    tasks?: Array<TaskShortView>;
    /**
     * 
     * @type {Array<CapabilitiesRequirementView>}
     * @memberof BatchShortViewBase
     */
    softResourcesRequirements?: Array<CapabilitiesRequirementView>;
    /**
     * 
     * @type {number}
     * @memberof BatchShortViewBase
     */
    requiredSoftResourcesAmount: number;
    /**
     * 
     * @type {ShortObjectType}
     * @memberof BatchShortViewBase
     */
    tpe: ShortObjectType;
}
/**
 * 
 * @export
 * @interface BreakView
 */
export interface BreakView {
    /**
     * 
     * @type {string}
     * @memberof BreakView
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof BreakView
     */
    end?: string;
}
/**
 * 
 * @export
 * @interface CancelToDoTasksView
 */
export interface CancelToDoTasksView {
    /**
     * If selectAll is false, task IDs to cancel. If selectAll is true, task IDs to exclude
     * @type {Array<number>}
     * @memberof CancelToDoTasksView
     */
    taskIds?: Array<number>;
    /**
     * Whether to cancel all relevant (unplanned, respecting the filter) tasks
     * @type {boolean}
     * @memberof CancelToDoTasksView
     */
    selectAll?: boolean;
    /**
     * 
     * @type {TaskFilterDefinition}
     * @memberof CancelToDoTasksView
     */
    filter?: TaskFilterDefinition;
}
/**
 * 
 * @export
 * @interface CapabilitiesRequirement
 */
export interface CapabilitiesRequirement {
    /**
     * 
     * @type {Array<number>}
     * @memberof CapabilitiesRequirement
     */
    capabilities?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof CapabilitiesRequirement
     */
    hardMode: boolean;
    /**
     * 
     * @type {ResourceRequirementType}
     * @memberof CapabilitiesRequirement
     */
    type: ResourceRequirementType;
}
/**
 * 
 * @export
 * @interface CapabilitiesRequirementView
 */
export interface CapabilitiesRequirementView {
    /**
     * 
     * @type {Array<Capability>}
     * @memberof CapabilitiesRequirementView
     */
    capabilities?: Array<Capability>;
}
/**
 * 
 * @export
 * @interface Capability
 */
export interface Capability {
    /**
     * 
     * @type {number}
     * @memberof Capability
     */
    id?: number;
    /**
     * 
     * @type {object}
     * @memberof Capability
     */
    externalId: object;
    /**
     * 
     * @type {string}
     * @memberof Capability
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Capability
     */
    groupName: string;
}
/**
 * 
 * @export
 * @interface DateTimeRange
 */
export interface DateTimeRange {
    /**
     * 
     * @type {string}
     * @memberof DateTimeRange
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof DateTimeRange
     */
    to?: string;
}
/**
 * 
 * @export
 * @interface DependenciesGraph
 */
export interface DependenciesGraph {
    /**
     * 
     * @type {TaskNode}
     * @memberof DependenciesGraph
     */
    entryNode?: TaskNode;
    /**
     * 
     * @type {Array<DependenciesGraphEdge>}
     * @memberof DependenciesGraph
     */
    edges?: Array<DependenciesGraphEdge>;
    /**
     * 
     * @type {Array<DependenciesGraphNodeAny>}
     * @memberof DependenciesGraph
     */
    nodes?: Array<DependenciesGraphNodeAny>;
}
/**
 * @type DependenciesGraphEdge
 * 
 * @export
 */
export type DependenciesGraphEdge = { edgeType: 'TaskToResourceEdge' } & TaskToResourceEdge | { edgeType: 'TaskToTaskEdge' } & TaskToTaskEdge;

/**
 * 
 * @export
 */
export const DependenciesGraphEdgeType = {
    TaskToDispatchOrderEdge: 'TaskToDispatchOrderEdge',
    TaskToResourceEdge: 'TaskToResourceEdge',
    TaskToTaskEdge: 'TaskToTaskEdge'
} as const;
export type DependenciesGraphEdgeType = typeof DependenciesGraphEdgeType[keyof typeof DependenciesGraphEdgeType];

/**
 * @type DependenciesGraphNodeAny
 * 
 * @export
 */
export type DependenciesGraphNodeAny = { nodeType: 'DispatchOrderNode' } & DispatchOrderNode | { nodeType: 'ResourceNode' } & ResourceNode | { nodeType: 'TaskNode' } & TaskNodeBase;

/**
 * 
 * @export
 */
export const DependenciesGraphNodeType = {
    DispatchOrderNode: 'DispatchOrderNode',
    ResourceNode: 'ResourceNode',
    TaskNode: 'TaskNode'
} as const;
export type DependenciesGraphNodeType = typeof DependenciesGraphNodeType[keyof typeof DependenciesGraphNodeType];

/**
 * 
 * @export
 * @interface DependencyDetails
 */
export interface DependencyDetails {
    /**
     * 
     * @type {number}
     * @memberof DependencyDetails
     */
    taskId: number;
    /**
     * 
     * @type {string}
     * @memberof DependencyDetails
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof DependencyDetails
     */
    end?: string;
    /**
     * 
     * @type {number}
     * @memberof DependencyDetails
     */
    queueId?: number;
    /**
     * 
     * @type {TaskStatus}
     * @memberof DependencyDetails
     */
    status: TaskStatus;
}
/**
 * 
 * @export
 * @interface DispatchOrderNode
 */
export interface DispatchOrderNode {
    /**
     * 
     * @type {number}
     * @memberof DispatchOrderNode
     */
    nodeId: number;
    /**
     * 
     * @type {number}
     * @memberof DispatchOrderNode
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof DispatchOrderNode
     */
    supplierOrderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchOrderNode
     */
    buyerName?: string;
    /**
     * 
     * @type {string}
     * @memberof DispatchOrderNode
     */
    deliveryDate?: string;
    /**
     * 
     * @type {DependenciesGraphNodeType}
     * @memberof DispatchOrderNode
     */
    nodeType: DependenciesGraphNodeType;
}
/**
 * 
 * @export
 * @interface ErrorDetails
 */
export interface ErrorDetails {
    /**
     * 
     * @type {string}
     * @memberof ErrorDetails
     */
    message: string;
}

/**
 * 
 * @export
 */
export const ErrorType = {
    External: 'External',
    MissingPlanDependencies: 'MissingPlanDependencies',
    Overdue: 'Overdue',
    Unfeasible: 'Unfeasible'
} as const;
export type ErrorType = typeof ErrorType[keyof typeof ErrorType];

/**
 * 
 * @export
 * @interface ForbiddenError
 */
export interface ForbiddenError {
    /**
     * 
     * @type {string}
     * @memberof ForbiddenError
     */
    message: string;
}
/**
 * 
 * @export
 * @interface FreezingBoundarySaveView
 */
export interface FreezingBoundarySaveView {
    /**
     * 
     * @type {number}
     * @memberof FreezingBoundarySaveView
     */
    simulationId: number;
    /**
     * 
     * @type {string}
     * @memberof FreezingBoundarySaveView
     */
    freezingBoundary: string;
}
/**
 * 
 * @export
 * @interface Fulfilled
 */
export interface Fulfilled {
    /**
     * 
     * @type {number}
     * @memberof Fulfilled
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof Fulfilled
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {string}
     * @memberof Fulfilled
     */
    itemTypeExternalId: string;
    /**
     * 
     * @type {number}
     * @memberof Fulfilled
     */
    requiredAmount: number;
    /**
     * 
     * @type {string}
     * @memberof Fulfilled
     */
    unitType: string;
    /**
     * 
     * @type {IngredientStatus}
     * @memberof Fulfilled
     */
    tpe: IngredientStatus;
}
/**
 * @type GanttObject
 * 
 * @export
 */
export type GanttObject = { tpe: 'Batch' } & BatchGanttViewBase | { tpe: 'Task' } & TaskGanttViewBase;

/**
 * 
 * @export
 */
export const GanttObjectType = {
    Batch: 'Batch',
    Task: 'Task'
} as const;
export type GanttObjectType = typeof GanttObjectType[keyof typeof GanttObjectType];

/**
 * 
 * @export
 * @interface GanttUpdate
 */
export interface GanttUpdate {
    /**
     * 
     * @type {Array<ProductionQueue>}
     * @memberof GanttUpdate
     */
    productionQueues?: Array<ProductionQueue>;
    /**
     * 
     * @type {string}
     * @memberof GanttUpdate
     */
    correlationId: string;
}
/**
 * 
 * @export
 * @interface GetGroupDetailsFilter
 */
export interface GetGroupDetailsFilter {
    /**
     * 
     * @type {string}
     * @memberof GetGroupDetailsFilter
     */
    from?: string;
    /**
     * 
     * @type {string}
     * @memberof GetGroupDetailsFilter
     */
    to?: string;
    /**
     * 
     * @type {string}
     * @memberof GetGroupDetailsFilter
     */
    resourceSearch?: string;
}

/**
 * 
 * @export
 */
export const IngredientStatus = {
    Fulfilled: 'Fulfilled',
    Missing: 'Missing'
} as const;
export type IngredientStatus = typeof IngredientStatus[keyof typeof IngredientStatus];

/**
 * 
 * @export
 * @interface IngredientSummary
 */
export interface IngredientSummary {
    /**
     * 
     * @type {number}
     * @memberof IngredientSummary
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof IngredientSummary
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {string}
     * @memberof IngredientSummary
     */
    itemTypeExternalId: string;
    /**
     * 
     * @type {number}
     * @memberof IngredientSummary
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof IngredientSummary
     */
    unitType: string;
}
/**
 * @type KanbanObject
 * 
 * @export
 */
export type KanbanObject = { tpe: 'Batch' } & BatchKanbanViewBase | { tpe: 'Task' } & KanbanTaskViewBase;

/**
 * 
 * @export
 */
export const KanbanObjectType = {
    Batch: 'Batch',
    Task: 'Task'
} as const;
export type KanbanObjectType = typeof KanbanObjectType[keyof typeof KanbanObjectType];

/**
 * 
 * @export
 * @interface KanbanProductionQueue
 */
export interface KanbanProductionQueue {
    /**
     * 
     * @type {KanbanQueueView}
     * @memberof KanbanProductionQueue
     */
    queue: KanbanQueueView;
    /**
     * 
     * @type {Array<KanbanObject>}
     * @memberof KanbanProductionQueue
     */
    tasks?: Array<KanbanObject>;
}
/**
 * 
 * @export
 * @interface KanbanQueueView
 */
export interface KanbanQueueView {
    /**
     * 
     * @type {number}
     * @memberof KanbanQueueView
     */
    id: number;
    /**
     * 
     * @type {object}
     * @memberof KanbanQueueView
     */
    externalId: object;
    /**
     * 
     * @type {QueueArea}
     * @memberof KanbanQueueView
     */
    area: QueueArea;
    /**
     * 
     * @type {string}
     * @memberof KanbanQueueView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof KanbanQueueView
     */
    shortName: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof KanbanQueueView
     */
    resources?: Array<number>;
    /**
     * 
     * @type {QueueStatus}
     * @memberof KanbanQueueView
     */
    status: QueueStatus;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanQueueView
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface KanbanTaskView
 */
export interface KanbanTaskView {
    /**
     * 
     * @type {number}
     * @memberof KanbanTaskView
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanTaskView
     */
    batchId?: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanTaskView
     */
    taskExecutionId?: number;
    /**
     * 
     * @type {object}
     * @memberof KanbanTaskView
     */
    externalId: object;
    /**
     * 
     * @type {number}
     * @memberof KanbanTaskView
     */
    queueId: number;
    /**
     * 
     * @type {string}
     * @memberof KanbanTaskView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof KanbanTaskView
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof KanbanTaskView
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof KanbanTaskView
     */
    end: string;
    /**
     * 
     * @type {string}
     * @memberof KanbanTaskView
     */
    setupEnd?: string;
    /**
     * 
     * @type {string}
     * @memberof KanbanTaskView
     */
    dueDate?: string;
    /**
     * 
     * @type {number}
     * @memberof KanbanTaskView
     */
    duration: number;
    /**
     * 
     * @type {TaskType}
     * @memberof KanbanTaskView
     */
    taskType: TaskType;
    /**
     * 
     * @type {TaskEstimatedDurations}
     * @memberof KanbanTaskView
     */
    estimatedDurations: TaskEstimatedDurations;
    /**
     * 
     * @type {TaskStatus}
     * @memberof KanbanTaskView
     */
    status: TaskStatus;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanTaskView
     */
    wasPaused: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanTaskView
     */
    isOngoing: boolean;
    /**
     * 
     * @type {Array<TaskError>}
     * @memberof KanbanTaskView
     */
    errors?: Array<TaskError>;
    /**
     * 
     * @type {TaskProgress}
     * @memberof KanbanTaskView
     */
    progress: TaskProgress;
    /**
     * 
     * @type {Array<OrderDetailsView>}
     * @memberof KanbanTaskView
     */
    orders?: Array<OrderDetailsView>;
    /**
     * 
     * @type {Array<ProductionLotTag>}
     * @memberof KanbanTaskView
     */
    productionLotTags?: Array<ProductionLotTag>;
    /**
     * 
     * @type {Array<string>}
     * @memberof KanbanTaskView
     */
    summary?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanTaskView
     */
    requiresAcceptance: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanTaskView
     */
    priority: boolean;
    /**
     * 
     * @type {Technology}
     * @memberof KanbanTaskView
     */
    technologyName?: Technology;
    /**
     * 
     * @type {ProductionOrderDetails}
     * @memberof KanbanTaskView
     */
    productionOrderDetails?: ProductionOrderDetails;
    /**
     * 
     * @type {Array<ResourceView>}
     * @memberof KanbanTaskView
     */
    softResourceAssignments?: Array<ResourceView>;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanTaskView
     */
    isBehindSchedule: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanTaskView
     */
    hasActiveDowntime: boolean;
}
/**
 * 
 * @export
 * @interface KanbanTaskViewBase
 */
export interface KanbanTaskViewBase {
    /**
     * 
     * @type {number}
     * @memberof KanbanTaskViewBase
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanTaskViewBase
     */
    batchId?: number;
    /**
     * 
     * @type {number}
     * @memberof KanbanTaskViewBase
     */
    taskExecutionId?: number;
    /**
     * 
     * @type {object}
     * @memberof KanbanTaskViewBase
     */
    externalId: object;
    /**
     * 
     * @type {number}
     * @memberof KanbanTaskViewBase
     */
    queueId: number;
    /**
     * 
     * @type {string}
     * @memberof KanbanTaskViewBase
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof KanbanTaskViewBase
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof KanbanTaskViewBase
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof KanbanTaskViewBase
     */
    end: string;
    /**
     * 
     * @type {string}
     * @memberof KanbanTaskViewBase
     */
    setupEnd?: string;
    /**
     * 
     * @type {string}
     * @memberof KanbanTaskViewBase
     */
    dueDate?: string;
    /**
     * 
     * @type {number}
     * @memberof KanbanTaskViewBase
     */
    duration: number;
    /**
     * 
     * @type {TaskType}
     * @memberof KanbanTaskViewBase
     */
    taskType: TaskType;
    /**
     * 
     * @type {TaskEstimatedDurations}
     * @memberof KanbanTaskViewBase
     */
    estimatedDurations: TaskEstimatedDurations;
    /**
     * 
     * @type {TaskStatus}
     * @memberof KanbanTaskViewBase
     */
    status: TaskStatus;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanTaskViewBase
     */
    wasPaused: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanTaskViewBase
     */
    isOngoing: boolean;
    /**
     * 
     * @type {Array<TaskError>}
     * @memberof KanbanTaskViewBase
     */
    errors?: Array<TaskError>;
    /**
     * 
     * @type {TaskProgress}
     * @memberof KanbanTaskViewBase
     */
    progress: TaskProgress;
    /**
     * 
     * @type {Array<OrderDetailsView>}
     * @memberof KanbanTaskViewBase
     */
    orders?: Array<OrderDetailsView>;
    /**
     * 
     * @type {Array<ProductionLotTag>}
     * @memberof KanbanTaskViewBase
     */
    productionLotTags?: Array<ProductionLotTag>;
    /**
     * 
     * @type {Array<string>}
     * @memberof KanbanTaskViewBase
     */
    summary?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanTaskViewBase
     */
    requiresAcceptance: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanTaskViewBase
     */
    priority: boolean;
    /**
     * 
     * @type {Technology}
     * @memberof KanbanTaskViewBase
     */
    technologyName?: Technology;
    /**
     * 
     * @type {ProductionOrderDetails}
     * @memberof KanbanTaskViewBase
     */
    productionOrderDetails?: ProductionOrderDetails;
    /**
     * 
     * @type {Array<ResourceView>}
     * @memberof KanbanTaskViewBase
     */
    softResourceAssignments?: Array<ResourceView>;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanTaskViewBase
     */
    isBehindSchedule: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof KanbanTaskViewBase
     */
    hasActiveDowntime: boolean;
    /**
     * 
     * @type {KanbanObjectType}
     * @memberof KanbanTaskViewBase
     */
    tpe: KanbanObjectType;
}
/**
 * 
 * @export
 * @interface KanbanUpdate
 */
export interface KanbanUpdate {
    /**
     * 
     * @type {Array<KanbanProductionQueue>}
     * @memberof KanbanUpdate
     */
    productionQueues?: Array<KanbanProductionQueue>;
    /**
     * 
     * @type {string}
     * @memberof KanbanUpdate
     */
    correlationId: string;
}
/**
 * 
 * @export
 * @interface Missing
 */
export interface Missing {
    /**
     * 
     * @type {number}
     * @memberof Missing
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {string}
     * @memberof Missing
     */
    itemTypeVariantName: string;
    /**
     * 
     * @type {string}
     * @memberof Missing
     */
    itemTypeExternalId: string;
    /**
     * 
     * @type {number}
     * @memberof Missing
     */
    requiredAmount: number;
    /**
     * 
     * @type {number}
     * @memberof Missing
     */
    forecastedAmount: number;
    /**
     * 
     * @type {number}
     * @memberof Missing
     */
    missingAmount: number;
    /**
     * 
     * @type {string}
     * @memberof Missing
     */
    unitType: string;
    /**
     * 
     * @type {IngredientStatus}
     * @memberof Missing
     */
    tpe: IngredientStatus;
}
/**
 * 
 * @export
 * @interface MissingStock
 */
export interface MissingStock {
    /**
     * 
     * @type {number}
     * @memberof MissingStock
     */
    itemTypeVariantId: number;
    /**
     * 
     * @type {number}
     * @memberof MissingStock
     */
    requiredAmount: number;
    /**
     * 
     * @type {number}
     * @memberof MissingStock
     */
    availableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof MissingStock
     */
    missingAmount: number;
}
/**
 * 
 * @export
 * @interface Order
 */
export interface Order {
    /**
     * 
     * @type {string}
     * @memberof Order
     */
    column: string;
    /**
     * 
     * @type {boolean}
     * @memberof Order
     */
    asc: boolean;
}
/**
 * 
 * @export
 * @interface OrderDetails
 */
export interface OrderDetails {
    /**
     * 
     * @type {number}
     * @memberof OrderDetails
     */
    orderId: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDetails
     */
    positionInOrder: number;
    /**
     * 
     * @type {string}
     * @memberof OrderDetails
     */
    buyerName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDetails
     */
    buyerShortName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDetails
     */
    buyerNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDetails
     */
    supplierOrderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDetails
     */
    deliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDetails
     */
    comments?: string;
}
/**
 * 
 * @export
 * @interface OrderDetailsView
 */
export interface OrderDetailsView {
    /**
     * 
     * @type {number}
     * @memberof OrderDetailsView
     */
    orderId: number;
    /**
     * 
     * @type {number}
     * @memberof OrderDetailsView
     */
    positionInOrder: number;
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsView
     */
    buyerName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsView
     */
    buyerShortName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsView
     */
    buyerNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsView
     */
    supplierOrderNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsView
     */
    deliveryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderDetailsView
     */
    comment?: string;
}

/**
 * 
 * @export
 */
export const OrderingColumn = {
    CreationDate: 'CreationDate',
    Status: 'Status'
} as const;
export type OrderingColumn = typeof OrderingColumn[keyof typeof OrderingColumn];

/**
 * 
 * @export
 * @interface Pieces
 */
export interface Pieces {
    /**
     * 
     * @type {string}
     * @memberof Pieces
     */
    name: string;
}
/**
 * 
 * @export
 * @interface PlanningBoundarySaveView
 */
export interface PlanningBoundarySaveView {
    /**
     * 
     * @type {number}
     * @memberof PlanningBoundarySaveView
     */
    simulationId: number;
    /**
     * 
     * @type {string}
     * @memberof PlanningBoundarySaveView
     */
    planningBoundary: string;
}
/**
 * 
 * @export
 * @interface PlanningWindowQueueView
 */
export interface PlanningWindowQueueView {
    /**
     * 
     * @type {QueueView}
     * @memberof PlanningWindowQueueView
     */
    queue: QueueView;
    /**
     * 
     * @type {Array<TaskGanttView>}
     * @memberof PlanningWindowQueueView
     */
    current?: Array<TaskGanttView>;
}
/**
 * 
 * @export
 * @interface PlanningWindowUnplannedTaskView
 */
export interface PlanningWindowUnplannedTaskView {
    /**
     * 
     * @type {number}
     * @memberof PlanningWindowUnplannedTaskView
     */
    id: number;
    /**
     * 
     * @type {object}
     * @memberof PlanningWindowUnplannedTaskView
     */
    externalId: object;
    /**
     * 
     * @type {string}
     * @memberof PlanningWindowUnplannedTaskView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PlanningWindowUnplannedTaskView
     */
    productName: string;
    /**
     * 
     * @type {ProductionOrderDetails}
     * @memberof PlanningWindowUnplannedTaskView
     */
    productionOrderDetails?: ProductionOrderDetails;
    /**
     * 
     * @type {number}
     * @memberof PlanningWindowUnplannedTaskView
     */
    requiredSoftResourcesAmount: number;
    /**
     * 
     * @type {number}
     * @memberof PlanningWindowUnplannedTaskView
     */
    batchId?: number;
    /**
     * 
     * @type {number}
     * @memberof PlanningWindowUnplannedTaskView
     */
    simulationId?: number;
    /**
     * 
     * @type {number}
     * @memberof PlanningWindowUnplannedTaskView
     */
    originalTaskId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PlanningWindowUnplannedTaskView
     */
    frozen: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PlanningWindowUnplannedTaskView
     */
    toPublish: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PlanningWindowUnplannedTaskView
     */
    priority: boolean;
    /**
     * 
     * @type {QapsSimulationDataView}
     * @memberof PlanningWindowUnplannedTaskView
     */
    qapsSimulationData?: QapsSimulationDataView;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof PlanningWindowUnplannedTaskView
     */
    totalAmount: AmountWithUnit;
}
/**
 * 
 * @export
 * @interface PlanningWindowView
 */
export interface PlanningWindowView {
    /**
     * 
     * @type {Array<PlanningWindowUnplannedTaskView>}
     * @memberof PlanningWindowView
     */
    unplanned?: Array<PlanningWindowUnplannedTaskView>;
    /**
     * 
     * @type {Array<PlanningWindowQueueView>}
     * @memberof PlanningWindowView
     */
    currentPlan?: Array<PlanningWindowQueueView>;
    /**
     * 
     * @type {number}
     * @memberof PlanningWindowView
     */
    simulationId?: number;
}
/**
 * 
 * @export
 * @interface ProductDetails
 */
export interface ProductDetails {
    /**
     * 
     * @type {number}
     * @memberof ProductDetails
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDetails
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDetails
     */
    code: string;
    /**
     * 
     * @type {number}
     * @memberof ProductDetails
     */
    itemTypeVariantId: number;
}
/**
 * 
 * @export
 * @interface ProductionLotTag
 */
export interface ProductionLotTag {
    /**
     * 
     * @type {number}
     * @memberof ProductionLotTag
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotTag
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionLotTag
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface ProductionOrderDetails
 */
export interface ProductionOrderDetails {
    /**
     * 
     * @type {number}
     * @memberof ProductionOrderDetails
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderDetails
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof ProductionOrderDetails
     */
    externalId?: string;
}
/**
 * 
 * @export
 * @interface ProductionOrderPriorityUpdate
 */
export interface ProductionOrderPriorityUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof ProductionOrderPriorityUpdate
     */
    priority: boolean;
}
/**
 * 
 * @export
 * @interface ProductionParameterName
 */
export interface ProductionParameterName {
    /**
     * 
     * @type {number}
     * @memberof ProductionParameterName
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionParameterName
     */
    name: string;
}
/**
 * 
 * @export
 * @interface ProductionPlanBatchEntryView
 */
export interface ProductionPlanBatchEntryView {
    /**
     * 
     * @type {number}
     * @memberof ProductionPlanBatchEntryView
     */
    batchId: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionPlanBatchEntryView
     */
    predecessorTaskId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionPlanBatchEntryView
     */
    queueId: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionPlanBatchEntryView
     */
    simulationId?: number;
}
/**
 * 
 * @export
 * @interface ProductionPlanEntry
 */
export interface ProductionPlanEntry {
    /**
     * 
     * @type {number}
     * @memberof ProductionPlanEntry
     */
    taskId: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionPlanEntry
     */
    predecessorTaskId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionPlanEntry
     */
    queueId: number;
    /**
     * 
     * @type {number}
     * @memberof ProductionPlanEntry
     */
    simulationId?: number;
}
/**
 * 
 * @export
 * @interface ProductionQueue
 */
export interface ProductionQueue {
    /**
     * 
     * @type {QueueView}
     * @memberof ProductionQueue
     */
    queue: QueueView;
    /**
     * 
     * @type {Array<GanttObject>}
     * @memberof ProductionQueue
     */
    tasks?: Array<GanttObject>;
}
/**
 * 
 * @export
 * @interface ProductionUnit
 */
export interface ProductionUnit {
    /**
     * 
     * @type {number}
     * @memberof ProductionUnit
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductionUnit
     */
    name: string;
}
/**
 * 
 * @export
 * @interface QapsSimulationData
 */
export interface QapsSimulationData {
    /**
     * 
     * @type {string}
     * @memberof QapsSimulationData
     */
    productionOrderIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof QapsSimulationData
     */
    operation: string;
    /**
     * 
     * @type {string}
     * @memberof QapsSimulationData
     */
    batchName?: string;
    /**
     * 
     * @type {string}
     * @memberof QapsSimulationData
     */
    material: string;
    /**
     * 
     * @type {string}
     * @memberof QapsSimulationData
     */
    recipeVersion: string;
}
/**
 * 
 * @export
 * @interface QapsSimulationDataView
 */
export interface QapsSimulationDataView {
    /**
     * 
     * @type {string}
     * @memberof QapsSimulationDataView
     */
    productionOrderIdentifier: string;
    /**
     * 
     * @type {string}
     * @memberof QapsSimulationDataView
     */
    operation: string;
    /**
     * 
     * @type {string}
     * @memberof QapsSimulationDataView
     */
    batchName?: string;
    /**
     * 
     * @type {string}
     * @memberof QapsSimulationDataView
     */
    material: string;
    /**
     * 
     * @type {string}
     * @memberof QapsSimulationDataView
     */
    recipeVersion: string;
    /**
     * 
     * @type {string}
     * @memberof QapsSimulationDataView
     */
    operationName: string;
}
/**
 * 
 * @export
 * @interface Queue
 */
export interface Queue {
    /**
     * 
     * @type {number}
     * @memberof Queue
     */
    id?: number;
    /**
     * 
     * @type {object}
     * @memberof Queue
     */
    externalId: object;
    /**
     * 
     * @type {QueueArea}
     * @memberof Queue
     */
    area: QueueArea;
    /**
     * 
     * @type {string}
     * @memberof Queue
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Queue
     */
    shortName: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof Queue
     */
    resources?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof Queue
     */
    ordinal: number;
    /**
     * 
     * @type {string}
     * @memberof Queue
     */
    modified: string;
    /**
     * 
     * @type {boolean}
     * @memberof Queue
     */
    moveForwardPendingTasks: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Queue
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface QueueArea
 */
export interface QueueArea {
    /**
     * 
     * @type {number}
     * @memberof QueueArea
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof QueueArea
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof QueueArea
     */
    hex: string;
}
/**
 * 
 * @export
 * @interface QueueDurationForecast
 */
export interface QueueDurationForecast {
    /**
     * 
     * @type {number}
     * @memberof QueueDurationForecast
     */
    duration: number;
}
/**
 * 
 * @export
 * @interface QueueProperties
 */
export interface QueueProperties {
    /**
     * 
     * @type {string}
     * @memberof QueueProperties
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof QueueProperties
     */
    shortName: string;
}

/**
 * 
 * @export
 */
export const QueueStatus = {
    Break: 'Break',
    Error: 'Error',
    Idle: 'Idle',
    InProgress: 'InProgress'
} as const;
export type QueueStatus = typeof QueueStatus[keyof typeof QueueStatus];

/**
 * 
 * @export
 * @interface QueueView
 */
export interface QueueView {
    /**
     * 
     * @type {number}
     * @memberof QueueView
     */
    id: number;
    /**
     * 
     * @type {object}
     * @memberof QueueView
     */
    externalId: object;
    /**
     * 
     * @type {QueueArea}
     * @memberof QueueView
     */
    area: QueueArea;
    /**
     * 
     * @type {string}
     * @memberof QueueView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof QueueView
     */
    shortName: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof QueueView
     */
    resources?: Array<number>;
    /**
     * 
     * @type {QueueStatus}
     * @memberof QueueView
     */
    status: QueueStatus;
    /**
     * 
     * @type {Array<BreakView>}
     * @memberof QueueView
     */
    breaks?: Array<BreakView>;
    /**
     * 
     * @type {boolean}
     * @memberof QueueView
     */
    active: boolean;
}
/**
 * 
 * @export
 * @interface ReleaseDateView
 */
export interface ReleaseDateView {
    /**
     * 
     * @type {string}
     * @memberof ReleaseDateView
     */
    internal?: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseDateView
     */
    external?: string;
    /**
     * 
     * @type {string}
     * @memberof ReleaseDateView
     */
    value?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReleaseDateView
     */
    isLocked: boolean;
}
/**
 * 
 * @export
 * @interface RequiredResources
 */
export interface RequiredResources {
    /**
     * 
     * @type {Array<ResourceRequirement>}
     * @memberof RequiredResources
     */
    required?: Array<ResourceRequirement>;
}
/**
 * 
 * @export
 * @interface Resource
 */
export interface Resource {
    /**
     * 
     * @type {number}
     * @memberof Resource
     */
    id?: number;
    /**
     * 
     * @type {object}
     * @memberof Resource
     */
    externalId: object;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Resource
     */
    externalName?: string;
    /**
     * 
     * @type {ResourceType}
     * @memberof Resource
     */
    resourceType: ResourceType;
    /**
     * 
     * @type {boolean}
     * @memberof Resource
     */
    deleted: boolean;
    /**
     * 
     * @type {number}
     * @memberof Resource
     */
    groupId?: number;
}
/**
 * 
 * @export
 * @interface ResourceAlternatives
 */
export interface ResourceAlternatives {
    /**
     * 
     * @type {Array<number>}
     * @memberof ResourceAlternatives
     */
    alternatives?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof ResourceAlternatives
     */
    hardMode: boolean;
    /**
     * 
     * @type {ResourceRequirementType}
     * @memberof ResourceAlternatives
     */
    type: ResourceRequirementType;
}
/**
 * 
 * @export
 * @interface ResourceAvailabilityMeta
 */
export interface ResourceAvailabilityMeta {
    /**
     * 
     * @type {ResourceAvailabilityMetaValue}
     * @memberof ResourceAvailabilityMeta
     */
    value: ResourceAvailabilityMetaValue;
    /**
     * 
     * @type {ResourceDetailsView}
     * @memberof ResourceAvailabilityMeta
     */
    resource: ResourceDetailsView;
}

/**
 * 
 * @export
 */
export const ResourceAvailabilityMetaValue = {
    Available: 'Available',
    PartiallyAvailable: 'PartiallyAvailable',
    Unavailable: 'Unavailable'
} as const;
export type ResourceAvailabilityMetaValue = typeof ResourceAvailabilityMetaValue[keyof typeof ResourceAvailabilityMetaValue];

/**
 * 
 * @export
 * @interface ResourceAvailabilityView
 */
export interface ResourceAvailabilityView {
    /**
     * 
     * @type {DateTimeRange}
     * @memberof ResourceAvailabilityView
     */
    range: DateTimeRange;
    /**
     * 
     * @type {boolean}
     * @memberof ResourceAvailabilityView
     */
    available: boolean;
    /**
     * 
     * @type {ResourceAvailabilityMetaValue}
     * @memberof ResourceAvailabilityView
     */
    availability: ResourceAvailabilityMetaValue;
}
/**
 * 
 * @export
 * @interface ResourceDetailsView
 */
export interface ResourceDetailsView {
    /**
     * 
     * @type {number}
     * @memberof ResourceDetailsView
     */
    id: number;
    /**
     * 
     * @type {ResourceType}
     * @memberof ResourceDetailsView
     */
    resourceType: ResourceType;
    /**
     * 
     * @type {string}
     * @memberof ResourceDetailsView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ResourceDetailsView
     */
    externalName?: string;
    /**
     * 
     * @type {Array<ResourceTag>}
     * @memberof ResourceDetailsView
     */
    tags?: Array<ResourceTag>;
    /**
     * 
     * @type {Array<Capability>}
     * @memberof ResourceDetailsView
     */
    capabilities?: Array<Capability>;
    /**
     * 
     * @type {Array<ResourceAvailabilityView>}
     * @memberof ResourceDetailsView
     */
    availabilities?: Array<ResourceAvailabilityView>;
    /**
     * 
     * @type {Array<ShortObjectView>}
     * @memberof ResourceDetailsView
     */
    tasks?: Array<ShortObjectView>;
}
/**
 * 
 * @export
 * @interface ResourceGroup
 */
export interface ResourceGroup {
    /**
     * 
     * @type {number}
     * @memberof ResourceGroup
     */
    id?: number;
    /**
     * 
     * @type {object}
     * @memberof ResourceGroup
     */
    externalId: object;
    /**
     * 
     * @type {string}
     * @memberof ResourceGroup
     */
    name: string;
}
/**
 * 
 * @export
 * @interface ResourceGroupTimeframeDetailsView
 */
export interface ResourceGroupTimeframeDetailsView {
    /**
     * 
     * @type {number}
     * @memberof ResourceGroupTimeframeDetailsView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ResourceGroupTimeframeDetailsView
     */
    name: string;
    /**
     * 
     * @type {Array<ResourceAvailabilityMeta>}
     * @memberof ResourceGroupTimeframeDetailsView
     */
    resources?: Array<ResourceAvailabilityMeta>;
    /**
     * 
     * @type {number}
     * @memberof ResourceGroupTimeframeDetailsView
     */
    available: number;
    /**
     * 
     * @type {number}
     * @memberof ResourceGroupTimeframeDetailsView
     */
    unavailable: number;
}
/**
 * 
 * @export
 * @interface ResourceNode
 */
export interface ResourceNode {
    /**
     * 
     * @type {number}
     * @memberof ResourceNode
     */
    nodeId: number;
    /**
     * 
     * @type {number}
     * @memberof ResourceNode
     */
    id: number;
    /**
     * 
     * @type {object}
     * @memberof ResourceNode
     */
    externalId: object;
    /**
     * 
     * @type {string}
     * @memberof ResourceNode
     */
    name: string;
    /**
     * 
     * @type {ResourceType}
     * @memberof ResourceNode
     */
    resourceType: ResourceType;
    /**
     * 
     * @type {DependenciesGraphNodeType}
     * @memberof ResourceNode
     */
    nodeType: DependenciesGraphNodeType;
}
/**
 * @type ResourceRequirement
 * 
 * @export
 */
export type ResourceRequirement = { type: 'CapabilitiesRequirement' } & CapabilitiesRequirement | { type: 'ResourceAlternatives' } & ResourceAlternatives;

/**
 * 
 * @export
 */
export const ResourceRequirementType = {
    CapabilitiesRequirement: 'CapabilitiesRequirement',
    ResourceAlternatives: 'ResourceAlternatives'
} as const;
export type ResourceRequirementType = typeof ResourceRequirementType[keyof typeof ResourceRequirementType];

/**
 * 
 * @export
 * @interface ResourceTag
 */
export interface ResourceTag {
    /**
     * 
     * @type {number}
     * @memberof ResourceTag
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ResourceTag
     */
    name: string;
}

/**
 * 
 * @export
 */
export const ResourceType = {
    Machine: 'Machine',
    Worker: 'Worker'
} as const;
export type ResourceType = typeof ResourceType[keyof typeof ResourceType];

/**
 * 
 * @export
 * @interface ResourceView
 */
export interface ResourceView {
    /**
     * 
     * @type {number}
     * @memberof ResourceView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ResourceView
     */
    name: string;
    /**
     * 
     * @type {object}
     * @memberof ResourceView
     */
    externalId: object;
    /**
     * 
     * @type {ResourceType}
     * @memberof ResourceView
     */
    resourceType: ResourceType;
}
/**
 * 
 * @export
 * @interface RetoolingMatrixDetailsView
 */
export interface RetoolingMatrixDetailsView {
    /**
     * 
     * @type {number}
     * @memberof RetoolingMatrixDetailsView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof RetoolingMatrixDetailsView
     */
    description?: string;
    /**
     * 
     * @type {Array<RetoolingMatrixEntryView>}
     * @memberof RetoolingMatrixDetailsView
     */
    entries?: Array<RetoolingMatrixEntryView>;
    /**
     * 
     * @type {Array<Queue>}
     * @memberof RetoolingMatrixDetailsView
     */
    queues?: Array<Queue>;
}
/**
 * 
 * @export
 * @interface RetoolingMatrixEntriesUpdate
 */
export interface RetoolingMatrixEntriesUpdate {
    /**
     * 
     * @type {string}
     * @memberof RetoolingMatrixEntriesUpdate
     */
    fromValue?: string;
    /**
     * 
     * @type {Array<RetoolingMatrixToValueUpdate>}
     * @memberof RetoolingMatrixEntriesUpdate
     */
    toValues?: Array<RetoolingMatrixToValueUpdate>;
}
/**
 * 
 * @export
 * @interface RetoolingMatrixEntryView
 */
export interface RetoolingMatrixEntryView {
    /**
     * 
     * @type {number}
     * @memberof RetoolingMatrixEntryView
     */
    productionParameterId: number;
    /**
     * 
     * @type {string}
     * @memberof RetoolingMatrixEntryView
     */
    fromValue?: string;
    /**
     * 
     * @type {string}
     * @memberof RetoolingMatrixEntryView
     */
    toValue?: string;
    /**
     * 
     * @type {number}
     * @memberof RetoolingMatrixEntryView
     */
    setupTimeMinutes?: number;
}
/**
 * 
 * @export
 * @interface RetoolingMatrixFilter
 */
export interface RetoolingMatrixFilter {
    /**
     * 
     * @type {string}
     * @memberof RetoolingMatrixFilter
     */
    description?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof RetoolingMatrixFilter
     */
    parameterIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof RetoolingMatrixFilter
     */
    queueIds?: Array<number>;
}
/**
 * 
 * @export
 * @interface RetoolingMatrixListItem
 */
export interface RetoolingMatrixListItem {
    /**
     * 
     * @type {number}
     * @memberof RetoolingMatrixListItem
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof RetoolingMatrixListItem
     */
    description?: string;
    /**
     * 
     * @type {ProductionParameterName}
     * @memberof RetoolingMatrixListItem
     */
    parameter: ProductionParameterName;
    /**
     * 
     * @type {Array<Queue>}
     * @memberof RetoolingMatrixListItem
     */
    queues?: Array<Queue>;
    /**
     * 
     * @type {string}
     * @memberof RetoolingMatrixListItem
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof RetoolingMatrixListItem
     */
    updatedAt?: string;
}
/**
 * 
 * @export
 * @interface RetoolingMatrixListOrdering
 */
export interface RetoolingMatrixListOrdering {
    /**
     * 
     * @type {RetoolingMatrixOrderingColumn}
     * @memberof RetoolingMatrixListOrdering
     */
    column: RetoolingMatrixOrderingColumn;
    /**
     * 
     * @type {boolean}
     * @memberof RetoolingMatrixListOrdering
     */
    asc: boolean;
}
/**
 * 
 * @export
 * @interface RetoolingMatrixListRequest
 */
export interface RetoolingMatrixListRequest {
    /**
     * 
     * @type {number}
     * @memberof RetoolingMatrixListRequest
     */
    take: number;
    /**
     * 
     * @type {number}
     * @memberof RetoolingMatrixListRequest
     */
    skip: number;
    /**
     * 
     * @type {RetoolingMatrixListOrdering}
     * @memberof RetoolingMatrixListRequest
     */
    order?: RetoolingMatrixListOrdering;
    /**
     * 
     * @type {RetoolingMatrixFilter}
     * @memberof RetoolingMatrixListRequest
     */
    filter: RetoolingMatrixFilter;
}
/**
 * 
 * @export
 * @interface RetoolingMatrixListResult
 */
export interface RetoolingMatrixListResult {
    /**
     * 
     * @type {Array<RetoolingMatrixListItem>}
     * @memberof RetoolingMatrixListResult
     */
    rows?: Array<RetoolingMatrixListItem>;
    /**
     * 
     * @type {number}
     * @memberof RetoolingMatrixListResult
     */
    total: number;
}
/**
 * 
 * @export
 * @interface RetoolingMatrixMetadata
 */
export interface RetoolingMatrixMetadata {
    /**
     * 
     * @type {Array<number>}
     * @memberof RetoolingMatrixMetadata
     */
    queueIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof RetoolingMatrixMetadata
     */
    description?: string;
}

/**
 * 
 * @export
 */
export const RetoolingMatrixOrderingColumn = {
    CreatedAt: 'CreatedAt',
    Description: 'Description',
    Id: 'Id',
    ProductionParameter: 'ProductionParameter',
    UpdatedAt: 'UpdatedAt'
} as const;
export type RetoolingMatrixOrderingColumn = typeof RetoolingMatrixOrderingColumn[keyof typeof RetoolingMatrixOrderingColumn];

/**
 * 
 * @export
 * @interface RetoolingMatrixToValueUpdate
 */
export interface RetoolingMatrixToValueUpdate {
    /**
     * 
     * @type {string}
     * @memberof RetoolingMatrixToValueUpdate
     */
    toValue?: string;
    /**
     * 
     * @type {number}
     * @memberof RetoolingMatrixToValueUpdate
     */
    setupTimeMinutes?: number;
}

/**
 * 
 * @export
 */
export const ShortObjectType = {
    Batch: 'Batch',
    Task: 'Task'
} as const;
export type ShortObjectType = typeof ShortObjectType[keyof typeof ShortObjectType];

/**
 * @type ShortObjectView
 * 
 * @export
 */
export type ShortObjectView = { tpe: 'Batch' } & BatchShortViewBase | { tpe: 'Task' } & TaskShortViewBase;
/**
 * 
 * @export
 * @interface SimulationApplyView
 */
export interface SimulationApplyView {
    /**
     * 
     * @type {number}
     * @memberof SimulationApplyView
     */
    simulationId: number;
}
/**
 * 
 * @export
 * @interface SimulationApplyingStatus
 */
export interface SimulationApplyingStatus {
    /**
     * 
     * @type {number}
     * @memberof SimulationApplyingStatus
     */
    simulationId: number;
    /**
     * 
     * @type {SimulationStatus}
     * @memberof SimulationApplyingStatus
     */
    status: SimulationStatus;
    /**
     * 
     * @type {string}
     * @memberof SimulationApplyingStatus
     */
    applyingError?: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationApplyingStatus
     */
    applyingStartDate: string;
}
/**
 * 
 * @export
 * @interface SimulationCancelTasksView
 */
export interface SimulationCancelTasksView {
    /**
     * If selectAll is false, task IDs to cancel. If selectAll is true, task IDs to exclude
     * @type {Array<number>}
     * @memberof SimulationCancelTasksView
     */
    taskIds?: Array<number>;
    /**
     * Whether to cancel all relevant (unplanned, respecting the filter) tasks
     * @type {boolean}
     * @memberof SimulationCancelTasksView
     */
    selectAll?: boolean;
    /**
     * 
     * @type {TaskFilterDefinition}
     * @memberof SimulationCancelTasksView
     */
    filter?: TaskFilterDefinition;
}
/**
 * 
 * @export
 * @interface SimulationCreateOptimizeView
 */
export interface SimulationCreateOptimizeView {
    /**
     * 
     * @type {Array<ApiSimulationParameterValue>}
     * @memberof SimulationCreateOptimizeView
     */
    parameterValues?: Array<ApiSimulationParameterValue>;
}
/**
 * 
 * @export
 * @interface SimulationFilterDefinition
 */
export interface SimulationFilterDefinition {
    /**
     * 
     * @type {number}
     * @memberof SimulationFilterDefinition
     */
    take: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationFilterDefinition
     */
    skip: number;
    /**
     * 
     * @type {SimulationListOrdering}
     * @memberof SimulationFilterDefinition
     */
    order?: SimulationListOrdering;
    /**
     * 
     * @type {SimulationListFilterData}
     * @memberof SimulationFilterDefinition
     */
    data: SimulationListFilterData;
}

/**
 * 
 * @export
 */
export const SimulationGetTasksFilterSortBy = {
    Amount: 'Amount',
    PlannedStart: 'PlannedStart',
    ProductName: 'ProductName',
    QueueName: 'QueueName'
} as const;
export type SimulationGetTasksFilterSortBy = typeof SimulationGetTasksFilterSortBy[keyof typeof SimulationGetTasksFilterSortBy];

/**
 * 
 * @export
 * @interface SimulationListFilterData
 */
export interface SimulationListFilterData {
    /**
     * 
     * @type {Array<SimulationListStatusView>}
     * @memberof SimulationListFilterData
     */
    status?: Array<SimulationListStatusView>;
    /**
     * 
     * @type {DateTimeRange}
     * @memberof SimulationListFilterData
     */
    creationDate?: DateTimeRange;
}
/**
 * 
 * @export
 * @interface SimulationListOrdering
 */
export interface SimulationListOrdering {
    /**
     * 
     * @type {OrderingColumn}
     * @memberof SimulationListOrdering
     */
    column: OrderingColumn;
    /**
     * 
     * @type {boolean}
     * @memberof SimulationListOrdering
     */
    asc: boolean;
}
/**
 * 
 * @export
 * @interface SimulationListResult
 */
export interface SimulationListResult {
    /**
     * 
     * @type {Array<SimulationListView>}
     * @memberof SimulationListResult
     */
    rows?: Array<SimulationListView>;
    /**
     * 
     * @type {number}
     * @memberof SimulationListResult
     */
    total: number;
}

/**
 * 
 * @export
 */
export const SimulationListStatusView = {
    Complete: 'Complete',
    Error: 'Error',
    InProgress: 'InProgress',
    New: 'New'
} as const;
export type SimulationListStatusView = typeof SimulationListStatusView[keyof typeof SimulationListStatusView];

/**
 * 
 * @export
 * @interface SimulationListView
 */
export interface SimulationListView {
    /**
     * 
     * @type {number}
     * @memberof SimulationListView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationListView
     */
    creationDate: string;
    /**
     * 
     * @type {SimulationListStatusView}
     * @memberof SimulationListView
     */
    status: SimulationListStatusView;
}
/**
 * 
 * @export
 * @interface SimulationMetadataSaveView
 */
export interface SimulationMetadataSaveView {
    /**
     * 
     * @type {number}
     * @memberof SimulationMetadataSaveView
     */
    simulationId: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationMetadataSaveView
     */
    planningBoundary: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationMetadataSaveView
     */
    freezingBoundary?: string;
}
/**
 * 
 * @export
 * @interface SimulationMetadataView
 */
export interface SimulationMetadataView {
    /**
     * 
     * @type {number}
     * @memberof SimulationMetadataView
     */
    simulationId: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationMetadataView
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationMetadataView
     */
    to: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationMetadataView
     */
    planningBoundary: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationMetadataView
     */
    freezingBoundary: string;
    /**
     * 
     * @type {Array<SimulationParameterValueView>}
     * @memberof SimulationMetadataView
     */
    parameters?: Array<SimulationParameterValueView>;
    /**
     * 
     * @type {Array<number>}
     * @memberof SimulationMetadataView
     */
    frozenTasks?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof SimulationMetadataView
     */
    tasksToPublish?: Array<number>;
    /**
     * 
     * @type {SimulationListStatusView}
     * @memberof SimulationMetadataView
     */
    status: SimulationListStatusView;
}

/**
 * 
 * @export
 */
export const SimulationParameterType = {
    Boolean: 'Boolean',
    Date: 'Date',
    Int: 'Int',
    String: 'String'
} as const;
export type SimulationParameterType = typeof SimulationParameterType[keyof typeof SimulationParameterType];

/**
 * 
 * @export
 * @interface SimulationParameterValueView
 */
export interface SimulationParameterValueView {
    /**
     * 
     * @type {number}
     * @memberof SimulationParameterValueView
     */
    id: number;
    /**
     * 
     * @type {SimulationParameterType}
     * @memberof SimulationParameterValueView
     */
    parameterType: SimulationParameterType;
    /**
     * 
     * @type {string}
     * @memberof SimulationParameterValueView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationParameterValueView
     */
    operationalName: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationParameterValueView
     */
    value: string;
}
/**
 * 
 * @export
 * @interface SimulationParameterView
 */
export interface SimulationParameterView {
    /**
     * 
     * @type {number}
     * @memberof SimulationParameterView
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationParameterView
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof SimulationParameterView
     */
    isOptional: boolean;
    /**
     * 
     * @type {string}
     * @memberof SimulationParameterView
     */
    operationalName: string;
    /**
     * 
     * @type {SimulationParameterType}
     * @memberof SimulationParameterView
     */
    parameterType: SimulationParameterType;
    /**
     * 
     * @type {string}
     * @memberof SimulationParameterView
     */
    defaultValue?: string;
    /**
     * 
     * @type {string}
     * @memberof SimulationParameterView
     */
    groupName?: string;
    /**
     * 
     * @type {number}
     * @memberof SimulationParameterView
     */
    ordinal?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationParameterView
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationParameterView
     */
    to?: number;
}

/**
 * 
 * @export
 */
export const SimulationStatus = {
    Applied: 'Applied',
    ApplyingGraphneChanges: 'ApplyingGraphneChanges',
    Error: 'Error',
    Initialized: 'Initialized',
    SendingPlanUpdate: 'SendingPlanUpdate',
    SendingToNexelem: 'SendingToNexelem',
    StartedApplying: 'StartedApplying',
    WaitingForPlanUpdateConfirmation: 'WaitingForPlanUpdateConfirmation',
    WaitingForTasks: 'WaitingForTasks'
} as const;
export type SimulationStatus = typeof SimulationStatus[keyof typeof SimulationStatus];


/**
 * 
 * @export
 */
export const SimulationTaskErrorSeverity = {
    Critical: 'Critical',
    Minor: 'Minor'
} as const;
export type SimulationTaskErrorSeverity = typeof SimulationTaskErrorSeverity[keyof typeof SimulationTaskErrorSeverity];

/**
 * 
 * @export
 * @interface SimulationTaskErrorView
 */
export interface SimulationTaskErrorView {
    /**
     * 
     * @type {number}
     * @memberof SimulationTaskErrorView
     */
    taskId: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationTaskErrorView
     */
    errorMessage: string;
    /**
     * 
     * @type {SimulationTaskErrorSeverity}
     * @memberof SimulationTaskErrorView
     */
    severity: SimulationTaskErrorSeverity;
}
/**
 * 
 * @export
 * @interface SimulationTaskUpdateAmountView
 */
export interface SimulationTaskUpdateAmountView {
    /**
     * 
     * @type {number}
     * @memberof SimulationTaskUpdateAmountView
     */
    amount: number;
}
/**
 * 
 * @export
 * @interface SimulationTaskUpdateRecipeVersionName
 */
export interface SimulationTaskUpdateRecipeVersionName {
    /**
     * 
     * @type {string}
     * @memberof SimulationTaskUpdateRecipeVersionName
     */
    recipeVersionName: string;
}
/**
 * 
 * @export
 * @interface SimulationTaskUpdateTechnologyView
 */
export interface SimulationTaskUpdateTechnologyView {
    /**
     * 
     * @type {Technology}
     * @memberof SimulationTaskUpdateTechnologyView
     */
    technologyName?: Technology;
}
/**
 * 
 * @export
 * @interface SimulationTasksUpdates
 */
export interface SimulationTasksUpdates {
    /**
     * 
     * @type {Array<SingleSimulationTaskUpdate>}
     * @memberof SimulationTasksUpdates
     */
    tasks?: Array<SingleSimulationTaskUpdate>;
}
/**
 * 
 * @export
 * @interface SimulationValidationResultView
 */
export interface SimulationValidationResultView {
    /**
     * 
     * @type {number}
     * @memberof SimulationValidationResultView
     */
    destinationSimulation: number;
    /**
     * 
     * @type {boolean}
     * @memberof SimulationValidationResultView
     */
    passed: boolean;
    /**
     * 
     * @type {Array<SimulationTaskErrorView>}
     * @memberof SimulationValidationResultView
     */
    errors?: Array<SimulationTaskErrorView>;
}
/**
 * 
 * @export
 * @interface SingleSimulationTaskUpdate
 */
export interface SingleSimulationTaskUpdate {
    /**
     * 
     * @type {number}
     * @memberof SingleSimulationTaskUpdate
     */
    taskId: number;
    /**
     * 
     * @type {number}
     * @memberof SingleSimulationTaskUpdate
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof SingleSimulationTaskUpdate
     */
    recipeVersionName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SingleSimulationTaskUpdate
     */
    priority?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SingleSimulationTaskUpdate
     */
    unplan: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof SingleSimulationTaskUpdate
     */
    mergeWith?: Array<number>;
}
/**
 * 
 * @export
 * @interface SoftResourceAreaUnassignmentRequest
 */
export interface SoftResourceAreaUnassignmentRequest {
    /**
     * 
     * @type {number}
     * @memberof SoftResourceAreaUnassignmentRequest
     */
    queueAreaId: number;
    /**
     * 
     * @type {string}
     * @memberof SoftResourceAreaUnassignmentRequest
     */
    from: string;
    /**
     * 
     * @type {string}
     * @memberof SoftResourceAreaUnassignmentRequest
     */
    to: string;
}
/**
 * 
 * @export
 * @interface SoftResourceAreaUnassignmentResultView
 */
export interface SoftResourceAreaUnassignmentResultView {
    /**
     * 
     * @type {Array<TaskSoftResourceUnassignmentView>}
     * @memberof SoftResourceAreaUnassignmentResultView
     */
    taskUnassignments?: Array<TaskSoftResourceUnassignmentView>;
}
/**
 * 
 * @export
 * @interface SoftResourceAssignment
 */
export interface SoftResourceAssignment {
    /**
     * 
     * @type {number}
     * @memberof SoftResourceAssignment
     */
    resourceId: number;
    /**
     * 
     * @type {number}
     * @memberof SoftResourceAssignment
     */
    taskId: number;
}
/**
 * 
 * @export
 * @interface SoftResourceAssignmentV2
 */
export interface SoftResourceAssignmentV2 {
    /**
     * 
     * @type {number}
     * @memberof SoftResourceAssignmentV2
     */
    taskId: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof SoftResourceAssignmentV2
     */
    resources?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof SoftResourceAssignmentV2
     */
    validateAvailability: boolean;
}
/**
 * 
 * @export
 * @interface SoftResourceBatchAssignment
 */
export interface SoftResourceBatchAssignment {
    /**
     * 
     * @type {number}
     * @memberof SoftResourceBatchAssignment
     */
    resourceId: number;
    /**
     * 
     * @type {number}
     * @memberof SoftResourceBatchAssignment
     */
    batchId: number;
}
/**
 * 
 * @export
 * @interface SoftResourceBatchAssignmentV2
 */
export interface SoftResourceBatchAssignmentV2 {
    /**
     * 
     * @type {number}
     * @memberof SoftResourceBatchAssignmentV2
     */
    batchId: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof SoftResourceBatchAssignmentV2
     */
    resources?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof SoftResourceBatchAssignmentV2
     */
    validateAvailability: boolean;
}
/**
 * 
 * @export
 * @interface SoftResourcesAssignmentFilter
 */
export interface SoftResourcesAssignmentFilter {
    /**
     * 
     * @type {number}
     * @memberof SoftResourcesAssignmentFilter
     */
    myGroup?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SoftResourcesAssignmentFilter
     */
    onlyAvailable: boolean;
    /**
     * 
     * @type {string}
     * @memberof SoftResourcesAssignmentFilter
     */
    name?: string;
    /**
     * 
     * @type {DateTimeRange}
     * @memberof SoftResourcesAssignmentFilter
     */
    dateTimeRange?: DateTimeRange;
}

/**
 * 
 * @export
 */
export const SortOrder = {
    Asc: 'Asc',
    Desc: 'Desc'
} as const;
export type SortOrder = typeof SortOrder[keyof typeof SortOrder];

/**
 * 
 * @export
 * @interface Tag
 */
export interface Tag {
    /**
     * 
     * @type {number}
     * @memberof Tag
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    name: string;
}
/**
 * 
 * @export
 * @interface Task
 */
export interface Task {
    /**
     * 
     * @type {number}
     * @memberof Task
     */
    id?: number;
    /**
     * 
     * @type {object}
     * @memberof Task
     */
    externalId: object;
    /**
     * 
     * @type {number}
     * @memberof Task
     */
    batchId?: number;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    internalReleaseDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    externalReleaseDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    dueDate?: string;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof Task
     */
    totalAmount: AmountWithUnit;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof Task
     */
    minimalTaskAmount?: AmountWithUnit;
    /**
     * 
     * @type {TaskType}
     * @memberof Task
     */
    taskType: TaskType;
    /**
     * 
     * @type {Array<Tag>}
     * @memberof Task
     */
    tags?: Array<Tag>;
    /**
     * 
     * @type {RequiredResources}
     * @memberof Task
     */
    requiredResources: RequiredResources;
    /**
     * 
     * @type {Array<TaskDependency>}
     * @memberof Task
     */
    dependsOn?: Array<TaskDependency>;
    /**
     * 
     * @type {Array<TaskError>}
     * @memberof Task
     */
    externalErrors?: Array<TaskError>;
    /**
     * 
     * @type {Array<OrderDetails>}
     * @memberof Task
     */
    orders?: Array<OrderDetails>;
    /**
     * 
     * @type {ProductDetails}
     * @memberof Task
     */
    productDetails: ProductDetails;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    hidden: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    cancelled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    completed: boolean;
    /**
     * 
     * @type {Array<ProductionLotTag>}
     * @memberof Task
     */
    productionLotTags?: Array<ProductionLotTag>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Task
     */
    summary?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    requiresAcceptance: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    priority: boolean;
    /**
     * 
     * @type {Technology}
     * @memberof Task
     */
    technology?: Technology;
    /**
     * 
     * @type {ProductionOrderDetails}
     * @memberof Task
     */
    productionOrderDetails?: ProductionOrderDetails;
    /**
     * 
     * @type {Array<Resource>}
     * @memberof Task
     */
    softResourceAssignments?: Array<Resource>;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    isBehindSchedule: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    hasActiveDowntime: boolean;
    /**
     * 
     * @type {number}
     * @memberof Task
     */
    requiredSoftResourcesAmount: number;
    /**
     * 
     * @type {number}
     * @memberof Task
     */
    simulationId?: number;
    /**
     * 
     * @type {number}
     * @memberof Task
     */
    originalTaskId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    frozen: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Task
     */
    toPublish: boolean;
    /**
     * 
     * @type {QapsSimulationData}
     * @memberof Task
     */
    qapsSimulationData?: QapsSimulationData;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Task
     */
    productionParameters: { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    lastAddedToQueueDate?: string;
    /**
     * 
     * @type {Array<IngredientSummary>}
     * @memberof Task
     */
    ingredientSummaries?: Array<IngredientSummary>;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    initialPlannedStartDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Task
     */
    publishGroupId?: string;
}
/**
 * 
 * @export
 * @interface TaskAddEntry
 */
export interface TaskAddEntry {
    /**
     * 
     * @type {number}
     * @memberof TaskAddEntry
     */
    taskId: number;
    /**
     * 
     * @type {number}
     * @memberof TaskAddEntry
     */
    queueId: number;
    /**
     * 
     * @type {string}
     * @memberof TaskAddEntry
     */
    startTime: string;
    /**
     * 
     * @type {boolean}
     * @memberof TaskAddEntry
     */
    blockedStart: boolean;
    /**
     * 
     * @type {number}
     * @memberof TaskAddEntry
     */
    overrideDuration?: number;
}
/**
 * 
 * @export
 * @interface TaskAvailableQueues
 */
export interface TaskAvailableQueues {
    /**
     * 
     * @type {Array<AvailableQueue>}
     * @memberof TaskAvailableQueues
     */
    queues?: Array<AvailableQueue>;
    /**
     * 
     * @type {number}
     * @memberof TaskAvailableQueues
     */
    suggestedQueueId: number;
}
/**
 * 
 * @export
 * @interface TaskDependenciesDetails
 */
export interface TaskDependenciesDetails {
    /**
     * 
     * @type {Array<DependencyDetails>}
     * @memberof TaskDependenciesDetails
     */
    parents?: Array<DependencyDetails>;
    /**
     * 
     * @type {Array<DependencyDetails>}
     * @memberof TaskDependenciesDetails
     */
    children?: Array<DependencyDetails>;
}
/**
 * 
 * @export
 * @interface TaskDependency
 */
export interface TaskDependency {
    /**
     * 
     * @type {number}
     * @memberof TaskDependency
     */
    dependencyTaskId: number;
    /**
     * 
     * @type {number}
     * @memberof TaskDependency
     */
    minComplete: number;
    /**
     * 
     * @type {number}
     * @memberof TaskDependency
     */
    minDuration: number;
}
/**
 * 
 * @export
 * @interface TaskError
 */
export interface TaskError {
    /**
     * 
     * @type {number}
     * @memberof TaskError
     */
    id?: number;
    /**
     * 
     * @type {ErrorType}
     * @memberof TaskError
     */
    errorType: ErrorType;
    /**
     * 
     * @type {string}
     * @memberof TaskError
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskError
     */
    occurrence?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TaskError
     */
    critical: boolean;
}
/**
 * 
 * @export
 * @interface TaskEstimatedDurations
 */
export interface TaskEstimatedDurations {
    /**
     * 
     * @type {number}
     * @memberof TaskEstimatedDurations
     */
    median: number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof TaskEstimatedDurations
     */
    durations: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface TaskFilterData
 */
export interface TaskFilterData {
    /**
     * 
     * @type {string}
     * @memberof TaskFilterData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskFilterData
     */
    productName?: string;
    /**
     * 
     * @type {Array<TaskType>}
     * @memberof TaskFilterData
     */
    taskTypes?: Array<TaskType>;
    /**
     * 
     * @type {DateTimeRange}
     * @memberof TaskFilterData
     */
    dueDate?: DateTimeRange;
    /**
     * 
     * @type {Array<number>}
     * @memberof TaskFilterData
     */
    queues?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof TaskFilterData
     */
    showOrders?: boolean;
}
/**
 * The filter to apply when using selectAll
 * @export
 * @interface TaskFilterDefinition
 */
export interface TaskFilterDefinition {
    /**
     * 
     * @type {number}
     * @memberof TaskFilterDefinition
     */
    take?: number;
    /**
     * 
     * @type {number}
     * @memberof TaskFilterDefinition
     */
    skip?: number;
    /**
     * 
     * @type {Order}
     * @memberof TaskFilterDefinition
     */
    order?: Order;
    /**
     * 
     * @type {TaskFilterData}
     * @memberof TaskFilterDefinition
     */
    data?: TaskFilterData;
    /**
     * 
     * @type {number}
     * @memberof TaskFilterDefinition
     */
    simulationId?: number;
}
/**
 * 
 * @export
 * @interface TaskGanttView
 */
export interface TaskGanttView {
    /**
     * 
     * @type {number}
     * @memberof TaskGanttView
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof TaskGanttView
     */
    taskExecutionId?: number;
    /**
     * 
     * @type {object}
     * @memberof TaskGanttView
     */
    externalId: object;
    /**
     * 
     * @type {number}
     * @memberof TaskGanttView
     */
    queueId: number;
    /**
     * 
     * @type {string}
     * @memberof TaskGanttView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TaskGanttView
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof TaskGanttView
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof TaskGanttView
     */
    end: string;
    /**
     * 
     * @type {string}
     * @memberof TaskGanttView
     */
    setupEnd?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskGanttView
     */
    dueDate?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskGanttView
     */
    duration: number;
    /**
     * 
     * @type {TaskDependenciesDetails}
     * @memberof TaskGanttView
     */
    dependenciesDetails?: TaskDependenciesDetails;
    /**
     * 
     * @type {TaskType}
     * @memberof TaskGanttView
     */
    taskType: TaskType;
    /**
     * 
     * @type {TaskEstimatedDurations}
     * @memberof TaskGanttView
     */
    estimatedDurations: TaskEstimatedDurations;
    /**
     * 
     * @type {TaskStatus}
     * @memberof TaskGanttView
     */
    status: TaskStatus;
    /**
     * 
     * @type {Array<TaskError>}
     * @memberof TaskGanttView
     */
    errors?: Array<TaskError>;
    /**
     * 
     * @type {TaskProgress}
     * @memberof TaskGanttView
     */
    progress: TaskProgress;
    /**
     * 
     * @type {Array<OrderDetailsView>}
     * @memberof TaskGanttView
     */
    orders?: Array<OrderDetailsView>;
    /**
     * 
     * @type {ProductionOrderDetails}
     * @memberof TaskGanttView
     */
    productionOrderDetails?: ProductionOrderDetails;
    /**
     * 
     * @type {Array<ResourceView>}
     * @memberof TaskGanttView
     */
    softResourceAssignments?: Array<ResourceView>;
    /**
     * 
     * @type {number}
     * @memberof TaskGanttView
     */
    requiredSoftResourcesAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TaskGanttView
     */
    batchId?: number;
    /**
     * 
     * @type {number}
     * @memberof TaskGanttView
     */
    simulationId?: number;
    /**
     * 
     * @type {number}
     * @memberof TaskGanttView
     */
    originalTaskId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TaskGanttView
     */
    frozen: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TaskGanttView
     */
    toPublish: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TaskGanttView
     */
    priority: boolean;
    /**
     * 
     * @type {QapsSimulationDataView}
     * @memberof TaskGanttView
     */
    qapsSimulationData?: QapsSimulationDataView;
    /**
     * 
     * @type {Array<MissingStock>}
     * @memberof TaskGanttView
     */
    missingStocks?: Array<MissingStock>;
    /**
     * 
     * @type {number}
     * @memberof TaskGanttView
     */
    segmentIndex: number;
    /**
     * 
     * @type {boolean}
     * @memberof TaskGanttView
     */
    isPaused: boolean;
}
/**
 * 
 * @export
 * @interface TaskGanttViewBase
 */
export interface TaskGanttViewBase {
    /**
     * 
     * @type {number}
     * @memberof TaskGanttViewBase
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof TaskGanttViewBase
     */
    taskExecutionId?: number;
    /**
     * 
     * @type {object}
     * @memberof TaskGanttViewBase
     */
    externalId: object;
    /**
     * 
     * @type {number}
     * @memberof TaskGanttViewBase
     */
    queueId: number;
    /**
     * 
     * @type {string}
     * @memberof TaskGanttViewBase
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TaskGanttViewBase
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof TaskGanttViewBase
     */
    start: string;
    /**
     * 
     * @type {string}
     * @memberof TaskGanttViewBase
     */
    end: string;
    /**
     * 
     * @type {string}
     * @memberof TaskGanttViewBase
     */
    setupEnd?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskGanttViewBase
     */
    dueDate?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskGanttViewBase
     */
    duration: number;
    /**
     * 
     * @type {TaskDependenciesDetails}
     * @memberof TaskGanttViewBase
     */
    dependenciesDetails?: TaskDependenciesDetails;
    /**
     * 
     * @type {TaskType}
     * @memberof TaskGanttViewBase
     */
    taskType: TaskType;
    /**
     * 
     * @type {TaskEstimatedDurations}
     * @memberof TaskGanttViewBase
     */
    estimatedDurations: TaskEstimatedDurations;
    /**
     * 
     * @type {TaskStatus}
     * @memberof TaskGanttViewBase
     */
    status: TaskStatus;
    /**
     * 
     * @type {Array<TaskError>}
     * @memberof TaskGanttViewBase
     */
    errors?: Array<TaskError>;
    /**
     * 
     * @type {TaskProgress}
     * @memberof TaskGanttViewBase
     */
    progress: TaskProgress;
    /**
     * 
     * @type {Array<OrderDetailsView>}
     * @memberof TaskGanttViewBase
     */
    orders?: Array<OrderDetailsView>;
    /**
     * 
     * @type {ProductionOrderDetails}
     * @memberof TaskGanttViewBase
     */
    productionOrderDetails?: ProductionOrderDetails;
    /**
     * 
     * @type {Array<ResourceView>}
     * @memberof TaskGanttViewBase
     */
    softResourceAssignments?: Array<ResourceView>;
    /**
     * 
     * @type {number}
     * @memberof TaskGanttViewBase
     */
    requiredSoftResourcesAmount: number;
    /**
     * 
     * @type {number}
     * @memberof TaskGanttViewBase
     */
    batchId?: number;
    /**
     * 
     * @type {number}
     * @memberof TaskGanttViewBase
     */
    simulationId?: number;
    /**
     * 
     * @type {number}
     * @memberof TaskGanttViewBase
     */
    originalTaskId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TaskGanttViewBase
     */
    frozen: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TaskGanttViewBase
     */
    toPublish: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TaskGanttViewBase
     */
    priority: boolean;
    /**
     * 
     * @type {QapsSimulationDataView}
     * @memberof TaskGanttViewBase
     */
    qapsSimulationData?: QapsSimulationDataView;
    /**
     * 
     * @type {Array<MissingStock>}
     * @memberof TaskGanttViewBase
     */
    missingStocks?: Array<MissingStock>;
    /**
     * 
     * @type {number}
     * @memberof TaskGanttViewBase
     */
    segmentIndex: number;
    /**
     * 
     * @type {boolean}
     * @memberof TaskGanttViewBase
     */
    isPaused: boolean;
    /**
     * 
     * @type {GanttObjectType}
     * @memberof TaskGanttViewBase
     */
    tpe: GanttObjectType;
}
/**
 * @type TaskIngredientView
 * 
 * @export
 */
export type TaskIngredientView = { tpe: 'Fulfilled' } & Fulfilled | { tpe: 'Missing' } & Missing;
/**
 * 
 * @export
 * @interface TaskIngredientsView
 */
export interface TaskIngredientsView {
    /**
     * 
     * @type {number}
     * @memberof TaskIngredientsView
     */
    taskId: number;
    /**
     * 
     * @type {string}
     * @memberof TaskIngredientsView
     */
    taskName: string;
    /**
     * 
     * @type {ProductDetails}
     * @memberof TaskIngredientsView
     */
    productDetails: ProductDetails;
    /**
     * 
     * @type {Array<TaskIngredientView>}
     * @memberof TaskIngredientsView
     */
    ingredients?: Array<TaskIngredientView>;
}
/**
 * 
 * @export
 * @interface TaskNode
 */
export interface TaskNode {
    /**
     * 
     * @type {number}
     * @memberof TaskNode
     */
    nodeId: number;
    /**
     * 
     * @type {number}
     * @memberof TaskNode
     */
    id: number;
    /**
     * 
     * @type {object}
     * @memberof TaskNode
     */
    externalId: object;
    /**
     * 
     * @type {string}
     * @memberof TaskNode
     */
    name: string;
    /**
     * 
     * @type {TaskType}
     * @memberof TaskNode
     */
    taskType: TaskType;
    /**
     * 
     * @type {Array<Tag>}
     * @memberof TaskNode
     */
    tags?: Array<Tag>;
    /**
     * 
     * @type {TaskStatus}
     * @memberof TaskNode
     */
    status: TaskStatus;
    /**
     * 
     * @type {Array<TaskError>}
     * @memberof TaskNode
     */
    errors?: Array<TaskError>;
    /**
     * 
     * @type {TaskProgress}
     * @memberof TaskNode
     */
    progress: TaskProgress;
    /**
     * 
     * @type {string}
     * @memberof TaskNode
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskNode
     */
    end?: string;
    /**
     * 
     * @type {ReleaseDateView}
     * @memberof TaskNode
     */
    releaseDate: ReleaseDateView;
    /**
     * 
     * @type {string}
     * @memberof TaskNode
     */
    dueDate?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskNode
     */
    resourcesCount: number;
    /**
     * 
     * @type {ProductDetails}
     * @memberof TaskNode
     */
    productDetails: ProductDetails;
    /**
     * 
     * @type {Queue}
     * @memberof TaskNode
     */
    queue?: Queue;
    /**
     * 
     * @type {ProductionOrderDetails}
     * @memberof TaskNode
     */
    productionOrderDetails?: ProductionOrderDetails;
    /**
     * 
     * @type {QapsSimulationData}
     * @memberof TaskNode
     */
    qapsSimulationData?: QapsSimulationData;
}
/**
 * 
 * @export
 * @interface TaskNodeBase
 */
export interface TaskNodeBase {
    /**
     * 
     * @type {number}
     * @memberof TaskNodeBase
     */
    nodeId: number;
    /**
     * 
     * @type {number}
     * @memberof TaskNodeBase
     */
    id: number;
    /**
     * 
     * @type {object}
     * @memberof TaskNodeBase
     */
    externalId: object;
    /**
     * 
     * @type {string}
     * @memberof TaskNodeBase
     */
    name: string;
    /**
     * 
     * @type {TaskType}
     * @memberof TaskNodeBase
     */
    taskType: TaskType;
    /**
     * 
     * @type {Array<Tag>}
     * @memberof TaskNodeBase
     */
    tags?: Array<Tag>;
    /**
     * 
     * @type {TaskStatus}
     * @memberof TaskNodeBase
     */
    status: TaskStatus;
    /**
     * 
     * @type {Array<TaskError>}
     * @memberof TaskNodeBase
     */
    errors?: Array<TaskError>;
    /**
     * 
     * @type {TaskProgress}
     * @memberof TaskNodeBase
     */
    progress: TaskProgress;
    /**
     * 
     * @type {string}
     * @memberof TaskNodeBase
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskNodeBase
     */
    end?: string;
    /**
     * 
     * @type {ReleaseDateView}
     * @memberof TaskNodeBase
     */
    releaseDate: ReleaseDateView;
    /**
     * 
     * @type {string}
     * @memberof TaskNodeBase
     */
    dueDate?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskNodeBase
     */
    resourcesCount: number;
    /**
     * 
     * @type {ProductDetails}
     * @memberof TaskNodeBase
     */
    productDetails: ProductDetails;
    /**
     * 
     * @type {Queue}
     * @memberof TaskNodeBase
     */
    queue?: Queue;
    /**
     * 
     * @type {ProductionOrderDetails}
     * @memberof TaskNodeBase
     */
    productionOrderDetails?: ProductionOrderDetails;
    /**
     * 
     * @type {QapsSimulationData}
     * @memberof TaskNodeBase
     */
    qapsSimulationData?: QapsSimulationData;
    /**
     * 
     * @type {DependenciesGraphNodeType}
     * @memberof TaskNodeBase
     */
    nodeType: DependenciesGraphNodeType;
}
/**
 * 
 * @export
 * @interface TaskProgress
 */
export interface TaskProgress {
    /**
     * 
     * @type {number}
     * @memberof TaskProgress
     */
    current: number;
    /**
     * 
     * @type {number}
     * @memberof TaskProgress
     */
    noks: number;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof TaskProgress
     */
    totalAmount: AmountWithUnit;
}
/**
 * 
 * @export
 * @interface TaskShortView
 */
export interface TaskShortView {
    /**
     * 
     * @type {number}
     * @memberof TaskShortView
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof TaskShortView
     */
    batchId?: number;
    /**
     * 
     * @type {TaskProgress}
     * @memberof TaskShortView
     */
    progress: TaskProgress;
    /**
     * 
     * @type {string}
     * @memberof TaskShortView
     */
    name: string;
    /**
     * 
     * @type {ProductDetails}
     * @memberof TaskShortView
     */
    productDetails: ProductDetails;
    /**
     * 
     * @type {string}
     * @memberof TaskShortView
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskShortView
     */
    end?: string;
    /**
     * 
     * @type {Queue}
     * @memberof TaskShortView
     */
    queue?: Queue;
    /**
     * 
     * @type {Array<CapabilitiesRequirementView>}
     * @memberof TaskShortView
     */
    softResourcesRequirements?: Array<CapabilitiesRequirementView>;
    /**
     * 
     * @type {number}
     * @memberof TaskShortView
     */
    requiredSoftResourcesAmount: number;
}
/**
 * 
 * @export
 * @interface TaskShortViewBase
 */
export interface TaskShortViewBase {
    /**
     * 
     * @type {number}
     * @memberof TaskShortViewBase
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof TaskShortViewBase
     */
    batchId?: number;
    /**
     * 
     * @type {TaskProgress}
     * @memberof TaskShortViewBase
     */
    progress: TaskProgress;
    /**
     * 
     * @type {string}
     * @memberof TaskShortViewBase
     */
    name: string;
    /**
     * 
     * @type {ProductDetails}
     * @memberof TaskShortViewBase
     */
    productDetails: ProductDetails;
    /**
     * 
     * @type {string}
     * @memberof TaskShortViewBase
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskShortViewBase
     */
    end?: string;
    /**
     * 
     * @type {Queue}
     * @memberof TaskShortViewBase
     */
    queue?: Queue;
    /**
     * 
     * @type {Array<CapabilitiesRequirementView>}
     * @memberof TaskShortViewBase
     */
    softResourcesRequirements?: Array<CapabilitiesRequirementView>;
    /**
     * 
     * @type {number}
     * @memberof TaskShortViewBase
     */
    requiredSoftResourcesAmount: number;
    /**
     * 
     * @type {ShortObjectType}
     * @memberof TaskShortViewBase
     */
    tpe: ShortObjectType;
}
/**
 * 
 * @export
 * @interface TaskSoftResourceUnassignmentView
 */
export interface TaskSoftResourceUnassignmentView {
    /**
     * 
     * @type {number}
     * @memberof TaskSoftResourceUnassignmentView
     */
    taskId: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof TaskSoftResourceUnassignmentView
     */
    removedResourceIds?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof TaskSoftResourceUnassignmentView
     */
    remainingResourceIds?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof TaskSoftResourceUnassignmentView
     */
    productName?: string;
}

/**
 * 
 * @export
 */
export const TaskStatus = {
    Cancelled: 'Cancelled',
    Completed: 'Completed',
    Error: 'Error',
    Hidden: 'Hidden',
    InProgress: 'InProgress',
    NotPlanned: 'NotPlanned',
    Pending: 'Pending'
} as const;
export type TaskStatus = typeof TaskStatus[keyof typeof TaskStatus];

/**
 * 
 * @export
 * @interface TaskToDoEntry
 */
export interface TaskToDoEntry {
    /**
     * 
     * @type {number}
     * @memberof TaskToDoEntry
     */
    id: number;
    /**
     * 
     * @type {object}
     * @memberof TaskToDoEntry
     */
    externalId: object;
    /**
     * 
     * @type {number}
     * @memberof TaskToDoEntry
     */
    batchId?: number;
    /**
     * 
     * @type {string}
     * @memberof TaskToDoEntry
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TaskToDoEntry
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof TaskToDoEntry
     */
    dueDate?: string;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof TaskToDoEntry
     */
    totalAmount: AmountWithUnit;
    /**
     * 
     * @type {TaskType}
     * @memberof TaskToDoEntry
     */
    taskType: TaskType;
    /**
     * 
     * @type {TaskEstimatedDurations}
     * @memberof TaskToDoEntry
     */
    estimatedDurations: TaskEstimatedDurations;
    /**
     * 
     * @type {TaskStatus}
     * @memberof TaskToDoEntry
     */
    status: TaskStatus;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskToDoEntry
     */
    comments?: Array<string>;
    /**
     * 
     * @type {ProductionOrderDetails}
     * @memberof TaskToDoEntry
     */
    productionOrderDetails?: ProductionOrderDetails;
}
/**
 * 
 * @export
 * @interface TaskToResourceEdge
 */
export interface TaskToResourceEdge {
    /**
     * 
     * @type {number}
     * @memberof TaskToResourceEdge
     */
    fromNode: number;
    /**
     * 
     * @type {number}
     * @memberof TaskToResourceEdge
     */
    toNode: number;
    /**
     * 
     * @type {DependenciesGraphEdgeType}
     * @memberof TaskToResourceEdge
     */
    edgeType: DependenciesGraphEdgeType;
}
/**
 * 
 * @export
 * @interface TaskToTaskEdge
 */
export interface TaskToTaskEdge {
    /**
     * 
     * @type {number}
     * @memberof TaskToTaskEdge
     */
    fromNode: number;
    /**
     * 
     * @type {number}
     * @memberof TaskToTaskEdge
     */
    toNode: number;
    /**
     * 
     * @type {TaskStatus}
     * @memberof TaskToTaskEdge
     */
    status: TaskStatus;
    /**
     * 
     * @type {DependenciesGraphEdgeType}
     * @memberof TaskToTaskEdge
     */
    edgeType: DependenciesGraphEdgeType;
}
/**
 * 
 * @export
 * @interface TaskTree
 */
export interface TaskTree {
    /**
     * 
     * @type {number}
     * @memberof TaskTree
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof TaskTree
     */
    supplierOrderNumber?: string;
    /**
     * 
     * @type {ToDoTreeType}
     * @memberof TaskTree
     */
    treeType: ToDoTreeType;
    /**
     * 
     * @type {string}
     * @memberof TaskTree
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TaskTree
     */
    productName?: string;
    /**
     * 
     * @type {object}
     * @memberof TaskTree
     */
    externalId?: object;
    /**
     * 
     * @type {string}
     * @memberof TaskTree
     */
    dueDate?: string;
    /**
     * 
     * @type {TaskStatus}
     * @memberof TaskTree
     */
    status?: TaskStatus;
    /**
     * 
     * @type {TaskType}
     * @memberof TaskTree
     */
    taskType?: TaskType;
    /**
     * 
     * @type {TaskEstimatedDurations}
     * @memberof TaskTree
     */
    estimatedDurations?: TaskEstimatedDurations;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof TaskTree
     */
    totalAmount?: AmountWithUnit;
    /**
     * 
     * @type {TaskProgress}
     * @memberof TaskTree
     */
    progress?: TaskProgress;
    /**
     * 
     * @type {Array<TaskTreeItem>}
     * @memberof TaskTree
     */
    dependencies?: Array<TaskTreeItem>;
    /**
     * 
     * @type {Array<number>}
     * @memberof TaskTree
     */
    notPlannedDependencies?: Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskTree
     */
    comments?: Array<string>;
}
/**
 * 
 * @export
 * @interface TaskTreeItem
 */
export interface TaskTreeItem {
    /**
     * 
     * @type {number}
     * @memberof TaskTreeItem
     */
    id: number;
    /**
     * 
     * @type {object}
     * @memberof TaskTreeItem
     */
    externalId: object;
    /**
     * 
     * @type {string}
     * @memberof TaskTreeItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TaskTreeItem
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof TaskTreeItem
     */
    dueDate?: string;
    /**
     * 
     * @type {AmountWithUnit}
     * @memberof TaskTreeItem
     */
    totalAmount: AmountWithUnit;
    /**
     * 
     * @type {TaskProgress}
     * @memberof TaskTreeItem
     */
    progress: TaskProgress;
    /**
     * 
     * @type {TaskType}
     * @memberof TaskTreeItem
     */
    taskType: TaskType;
    /**
     * 
     * @type {TaskEstimatedDurations}
     * @memberof TaskTreeItem
     */
    estimatedDurations: TaskEstimatedDurations;
    /**
     * 
     * @type {TaskStatus}
     * @memberof TaskTreeItem
     */
    status: TaskStatus;
    /**
     * 
     * @type {Array<TaskTreeItem>}
     * @memberof TaskTreeItem
     */
    dependencies?: Array<TaskTreeItem>;
    /**
     * 
     * @type {Array<number>}
     * @memberof TaskTreeItem
     */
    notPlannedDependencies?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof TaskTreeItem
     */
    matchedPath: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskTreeItem
     */
    comments?: Array<string>;
}

/**
 * 
 * @export
 */
export const TaskType = {
    Delivery: 'Delivery',
    Packaging: 'Packaging',
    Production: 'Production',
    Supply: 'Supply',
    Transport: 'Transport'
} as const;
export type TaskType = typeof TaskType[keyof typeof TaskType];

/**
 * 
 * @export
 * @interface TaskView
 */
export interface TaskView {
    /**
     * 
     * @type {number}
     * @memberof TaskView
     */
    id: number;
    /**
     * 
     * @type {object}
     * @memberof TaskView
     */
    externalId: object;
    /**
     * 
     * @type {string}
     * @memberof TaskView
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TaskView
     */
    start?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskView
     */
    setupEnd?: string;
    /**
     * 
     * @type {string}
     * @memberof TaskView
     */
    end?: string;
    /**
     * 
     * @type {number}
     * @memberof TaskView
     */
    duration?: number;
    /**
     * 
     * @type {number}
     * @memberof TaskView
     */
    pauseDuration: number;
    /**
     * 
     * @type {ReleaseDateView}
     * @memberof TaskView
     */
    releaseDate: ReleaseDateView;
    /**
     * 
     * @type {string}
     * @memberof TaskView
     */
    dueDate?: string;
    /**
     * 
     * @type {TaskType}
     * @memberof TaskView
     */
    taskType: TaskType;
    /**
     * 
     * @type {Array<Tag>}
     * @memberof TaskView
     */
    tags?: Array<Tag>;
    /**
     * 
     * @type {Array<TaskDependency>}
     * @memberof TaskView
     */
    dependsOn?: Array<TaskDependency>;
    /**
     * 
     * @type {TaskEstimatedDurations}
     * @memberof TaskView
     */
    estimatedDurations: TaskEstimatedDurations;
    /**
     * 
     * @type {TaskStatus}
     * @memberof TaskView
     */
    status: TaskStatus;
    /**
     * 
     * @type {Array<TaskError>}
     * @memberof TaskView
     */
    errors?: Array<TaskError>;
    /**
     * 
     * @type {TaskProgress}
     * @memberof TaskView
     */
    progress: TaskProgress;
    /**
     * 
     * @type {string}
     * @memberof TaskView
     */
    aborted?: string;
    /**
     * 
     * @type {Queue}
     * @memberof TaskView
     */
    queue?: Queue;
    /**
     * 
     * @type {Array<OrderDetailsView>}
     * @memberof TaskView
     */
    orders?: Array<OrderDetailsView>;
    /**
     * 
     * @type {Array<ResourceView>}
     * @memberof TaskView
     */
    resources?: Array<ResourceView>;
    /**
     * 
     * @type {Array<ResourceView>}
     * @memberof TaskView
     */
    softResources?: Array<ResourceView>;
    /**
     * 
     * @type {ProductDetails}
     * @memberof TaskView
     */
    productDetails: ProductDetails;
    /**
     * 
     * @type {ProductionOrderDetails}
     * @memberof TaskView
     */
    productionOrderDetails?: ProductionOrderDetails;
    /**
     * 
     * @type {Array<ResourceView>}
     * @memberof TaskView
     */
    softResourceAssignments?: Array<ResourceView>;
    /**
     * 
     * @type {boolean}
     * @memberof TaskView
     */
    priority: boolean;
    /**
     * 
     * @type {number}
     * @memberof TaskView
     */
    originalTaskId?: number;
    /**
     * 
     * @type {QapsSimulationData}
     * @memberof TaskView
     */
    qapsSimulationData?: QapsSimulationData;
    /**
     * 
     * @type {number}
     * @memberof TaskView
     */
    requiredSoftResourcesAmount: number;
    /**
     * 
     * @type {string}
     * @memberof TaskView
     */
    initialPlannedStartDate?: string;
}
/**
 * @type Technology
 * 
 * @export
 */
export type Technology = Pieces | object;
/**
 * 
 * @export
 * @interface ToDoListView
 */
export interface ToDoListView {
    /**
     * 
     * @type {Array<TaskToDoEntry>}
     * @memberof ToDoListView
     */
    tasks?: Array<TaskToDoEntry>;
    /**
     * 
     * @type {number}
     * @memberof ToDoListView
     */
    total: number;
}

/**
 * 
 * @export
 */
export const ToDoTreeType = {
    DispatchOrder: 'DispatchOrder',
    Task: 'Task'
} as const;
export type ToDoTreeType = typeof ToDoTreeType[keyof typeof ToDoTreeType];

/**
 * 
 * @export
 * @interface ToDoTrees
 */
export interface ToDoTrees {
    /**
     * 
     * @type {Array<TaskTree>}
     * @memberof ToDoTrees
     */
    trees?: Array<TaskTree>;
    /**
     * 
     * @type {number}
     * @memberof ToDoTrees
     */
    total: number;
}
/**
 * 
 * @export
 * @interface UnauthorizedError
 */
export interface UnauthorizedError {
    /**
     * 
     * @type {string}
     * @memberof UnauthorizedError
     */
    message: string;
}
